import {commpatService} from "@/services/commpat";

export const RecordMixin = {
  methods: {
    handlerRecord(record) {
      this.$weuijs.actionSheet([
        {
          label: '重新绑定',
          onClick: () => {
            this.repeatRecord(record);
          }
        }, {
          label: '解除绑定',
          onClick: () => {
            this.cancelRecord(record);
          }
        }
      ], [
        {
          label: '取消',
          onClick: () => {
          }
        }
      ], {
        isAndroid: false
      })
    },
    repeatRecord(record) {
      this.$weuijs.confirm('重新绑定需要重新验证姓名、身份证、手机号和院内是否一致。' + '<br/>' + '若验证失败，将自动解除绑定当前病案号。', {
        isAndroid: false,
        buttons: [
          {
            label: '确定重绑',
            type: 'primary',
            onClick: () => {
              this.doRepeatRecord(record);
            }
          }, {
            label: '暂不操作',
            type: 'default',
            onClick: () => {

            }
          }
        ]
      })
    },
    cancelRecord(record) {
      this.$weuijs.confirm('解除绑定后您将无法挂号、查报告等。您可随时重新绑定。', {
        isAndroid: false,
        buttons: [
          {
            label: '确定解绑',
            type: 'primary',
            onClick: () => {
              this.doCancelRecord(record);
            }
          }, {
            label: '暂不操作',
            type: 'default',
            onClick: () => {

            }
          }
        ]
      })
    },

    /**
     * 解绑
     * @param record
     * @returns {Promise<void>}
     */
    async doCancelRecord(record) {
      if (await commpatService.unbind(record.id)) {
        this.$weuijs.toast('解绑成功', {
          duration: 3000,
          callback() {
            location.reload();
          }
        });
      }
    },

    /**
     * 重新绑定操作
     * @param record
     * @returns {Promise<void>}
     */
    async doRepeatRecord(record) {
      Log('第一步，解绑');
      if (await commpatService.unbind(record.id)) {
        if (this.$route.path === '/hospital') location.reload();
        else this.$router.push({path: '/hospital', query: {action: 'auth', compatId: this.$route.query.compatId}});
      } else {
        bus.$emit('msg', '解绑失败');
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/lib/mixins/record.js